export function getOverviewPath() {
  return '/ueberblick'
}
